module.exports = __webpack_public_path__ + "static/media/badge10.78a635e9.svg";